module.exports = __webpack_public_path__ + "static/media/Errorimg.c5699623.png";